import React from "react";

const Button = ({
  children,
  variant = "primary",
  onClick,
  href,
  className = "",
}) => {
  const baseStyles =
    "px-8 py-4 rounded-lg font-semibold transition-all inline-flex items-center space-x-2";

  const variants = {
    primary:
      "bg-gradient-to-r from-emerald-600 to-teal-600 text-white hover:shadow-xl",
    secondary:
      "border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50",
    outline:
      "border border-gray-300 text-gray-700 hover:border-emerald-600 hover:text-emerald-600",
  };

  const Component = href ? "a" : "button";

  return (
    <Component
      href={href}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
    >
      {children}
    </Component>
  );
};

export default Button;
